import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useSession } from '../../store/session';

export function RequireAuth({ children }: { children: ReactNode }) {
  const status = useSession((s) => s.status);
  const user = useSession((s) => s.user);
  const location = useLocation();
  if (status === 'loading') return null;
  if (status === 'anonymous') return <Navigate to="/login" replace />;
  if (user?.mustChangePassword && location.pathname !== '/password') return <Navigate to="/password" replace />;
  return <>{children}</>;
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const user = useSession((s) => s.user);
  if (user?.role !== 'admin') return <Navigate to="/" replace />;
  return <>{children}</>;
}
